<form
	class=""
	[formGroup]="form"
	novalidate
>
	<div class="sdp-gateway-graphical-edit-container">
		<div class="sdp-gateway-graphical-header">
			<sdp-icon [icon]="internetIcon"></sdp-icon>
			<div>Internet</div>
			<div class="sdp-gateway-warning-text"
			*ngIf="form.hasError('hasOverlappingIpPorts')"
				matTooltip="{{ 'warning.form.has.overlapping-ip-ports' | translate }}"
				matTooltipPosition="above"
			>
				<sdp-icon [icon]="warningIcon"></sdp-icon>
				{{ "warning.form.has.overlapping-ip-ports.short" | translate }}
		</div>
		</div>
		<div class="sdp-gateway-graphical-header">
		</div>
		<div class="sdp-gateway-graphical-header">
			<sdp-icon [icon]="gatewayIcon"></sdp-icon>
			<div class="sdp-gateway-header-svg-icon-offset">Gateway</div>
		</div>
		<div class="">
			<mat-card>
				<mat-form-field>
					<input
						matInput
						placeholder="{{ 'gateway.edit.publicIp' | translate }}"
						type="text"
						formControlName="publicIp"
					>
					<mat-error *ngIf="form.controls['publicIp'].hasError('required') || form.controls['publicIp'].hasError('invalidIp')">
						{{ "error.form.ip" | translate }}
					</mat-error>
				</mat-form-field>
			</mat-card>
		</div>
		<div class="sdp-gateway-graphical-divider">
		</div>
		<div class="">
			<mat-card class="sdp-right-side">
				<div class="sdp-arrow-shaft">
					<div class="sdp-arrow-shaft-icon sdp-arrow-shaft-icon-no-text">
						<sdp-icon [icon]="firewallIcon"></sdp-icon>
					</div>
				</div>
				<div class="sdp-arrow-right"></div>
				<mat-form-field>
					<input
						matInput
						placeholder="{{ 'gateway.edit.privateIp' | translate }}"
						type="text"
						formControlName="privateIp"
					>
					<mat-error *ngIf="form.controls['privateIp'].hasError('required') || form.controls['privateIp'].hasError('invalidIp')">
						{{ "error.form.ip" | translate }}
					</mat-error>
				</mat-form-field>
			</mat-card>
		</div>
		<div class="">
			<mat-card>
				<mat-form-field>
					<input
						matInput
						placeholder="{{ 'gateway.edit.external.tunnel.port' | translate }}"
						formControlName="publicOpenVpnPort"
						[errorStateMatcher]="publicPortMatcher"
					>
					<mat-error *ngIf="form.controls['publicOpenVpnPort'].hasError('required') || form.controls['publicOpenVpnPort'].hasError('invalidPort')">
						{{ "error.form.portNumber" | translate }}
					</mat-error>
					<mat-error *ngIf="form.hasError('valuesAreSame')">
						{{ "error.form.port.same" | translate }}
					</mat-error>
				</mat-form-field>
			</mat-card>
		</div>
		<div>
			<mat-card class="sdp-right-side sdp-gateway-edit-raw">
				<div class="sdp-arrow-shaft">
					<div class="sdp-arrow-shaft-icon">
						<sdp-icon [icon]="firewallIcon"></sdp-icon>
						<div class="sdp-gateway-arrow-text">port forward</div>
					</div>
				</div>
				<div class="sdp-arrow-right"></div>
				<div class="sdp-gateway-edit-raw-label">{{ 'gateway.edit.internal.tunnel.port' | translate }}</div>
				<div class="sdp-gateway-edit-raw-text">{{ OPENVPNPORT }}</div>
			</mat-card>
		</div>
		<div class="">
			<mat-card>
				<mat-form-field>
					<input
						matInput
						placeholder="{{ 'gateway.edit.external.security.port' | translate }}"
						formControlName="publicFwknopPort"
						[errorStateMatcher]="publicPortMatcher"
					>
					<mat-error *ngIf="form.controls['publicFwknopPort'].hasError('required') || form.controls['publicFwknopPort'].hasError('invalidPort')">
						{{ "error.form.portNumber" | translate }}
					</mat-error>
					<mat-error *ngIf="form.hasError('valuesAreSame')">
						{{ "error.form.port.same" | translate }}
					</mat-error>
				</mat-form-field>
			</mat-card>
		</div>
		<div>
			<mat-card class="sdp-right-side sdp-gateway-edit-raw">
				<div class="sdp-arrow-shaft">
					<div class="sdp-arrow-shaft-icon">
						<sdp-icon [icon]="firewallIcon"></sdp-icon>
						<div class="sdp-gateway-arrow-text">port forward</div>
					</div>
				</div>
				<div class="sdp-arrow-right"></div>
				<div class="sdp-gateway-edit-raw-label">{{ 'gateway.edit.internal.security.port' | translate }}</div>
				<div class="sdp-gateway-edit-raw-text">{{ FWKNOPPORT }}</div>
			</mat-card>
		</div>
	</div>
</form>